import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';
import {
  TooltipCell as SharedTooltipCell,
  type TooltipCellProps as SharedTooltipCellProps,
} from '@/components/TooltipCell';
import React from 'react';

export type TooltipCellProps = Omit<SharedTooltipCellProps, 'alwaysShow'>;

// NA-5596 (AC4): scoped to the Approval Drawer's Table layout only. Delegates
// to the shared `TooltipCell` (also used, unmodified, by the main invoice
// list) so the clamp-only display added here can never leak into that list's
// always-show behavior. Gated behind `approval-drawer-view-optimization` so
// the drawer keeps its old always-show fallback while the flag is off.
export const TooltipCell: React.FC<TooltipCellProps> = (props) => {
  const isViewOptimizationEnabled = useApprovalDrawerViewOptimizationFlag();

  return (
    <SharedTooltipCell {...props} alwaysShow={!isViewOptimizationEnabled} />
  );
};
